import React, {useState, useEffect} from 'react';
import {connectHits} from 'react-instantsearch-dom';
import ProjectFavorite from './ProjectFavorite';


import "./styles.css";

const Hits = ({hits}) => {

    const [isLoading, setIsLoading] = useState(true);
    const [canView, setCanView] = useState(true);

    const _onMouseEnter = (id) => {
        let el = document.getElementById('marker-item-' + id);
        if (el) {
            let img = el.dataset.hover;
            el.src = img;
        }
    }

    const _onMouseLeave = (id) => {
        let el = document.getElementById('marker-item-' + id);
        if (el) {
            let img = el.dataset.img;
            el.src = img;
        }
    }

    const _onMouseDown = (slug) => {
        if (canView === true) {
            if (window.win_language_code !== 'en') {
                let redirect_url = '/' + window.win_language_code + '/projects/' + slug
                window.location.href = redirect_url
            } else {
                window.location.href = '/projects/' + slug;
            }
        }
    }

    const _onFavoriteMouseEnter = () => {
        console.log('c', canView);
        setCanView(false);
        console.log('d', canView);
    }


    const _onFavoriteMouseLeave = () => {
        setCanView(true);
    }


    const HitLoads = () => {
        return (
            <div className={`project project--inline`}>
                <div className="project__image" style={{backgroundColor: '#e2e2e2'}}></div>
                <div className="project__content">
                    <div className="project__content-head">
                        <div className="project__content-head-inner">
                            <h4 className="project__title">
                                <span style={{
                                    width: '246px',
                                    height: '19px',
                                    display: 'block',
                                    backgroundColor: '#e2e2e2'
                                }}></span>
                                <span style={{
                                    width: '182px',
                                    height: '19px',
                                    marginTop: '3px',
                                    display: 'block',
                                    backgroundColor: '#e2e2e2'
                                }}></span>
                            </h4>
                            <span className="project__location">
                <span style={{width: '144px', height: '15px', marginTop: '8px', backgroundColor: '#e2e2e2'}}></span>
              </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    let loadingRows = [];
    for (var i = 0; i < 8; i++) {
        // note: we are adding a key prop here to allow react to uniquely identify each
        // element in this array. see: https://reactjs.org/docs/lists-and-keys.html
        loadingRows.push(<HitLoads key={i}/>);
    }

    useEffect(() => {
        if (hits.length > 0) {
            setIsLoading(false);
        } else {
            let timer = setTimeout(() => setIsLoading(false), 3000);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [hits]);

    return (
        <React.Fragment>
            <div className="projects" style={{paddingBottom: '5px'}}>
                {isLoading && loadingRows}
                {hits.filter(hit => {
                    //console.log('hitFiler', hit) href={'/projects/' + hit.objectID};
                    return !hit.is_unclaimed
                }).map(hit => (
                    <div key={hit.objectID}
                         id={'project-list-' + hit.objectID}
                         className={`project project--inline`}
                         onMouseEnter={() => _onMouseEnter(hit.objectID)}
                         onMouseLeave={() => _onMouseLeave(hit.objectID)}
                         onMouseDown={() => _onMouseDown(hit.slug)}>

                        <div className="project__image" style={{backgroundImage: 'url(' + hit.map_image + ')'}}></div>
                        <div className="project__content">
                            <div className="project__content-head">
                                <div className="project__content-head-inner">
                                    <h4 className="project__title">
                                        {hit.name}
                                    </h4>
                                    <span className="project__location">
                <span>{hit.building_system_name}</span>
              </span>
                                </div>
                            </div>
                        </div>
                        <ProjectFavorite item={hit} onMouseOut={() => _onFavoriteMouseLeave()}
                                         onMouseOver={_onFavoriteMouseEnter}/>
                    </div>

                ))}
            </div>
            <div className="map__results-cta">
                <h4>Looking for something else?</h4>
                <p>Try expanding the geographic area or removing filters. If you still don’t find what you need, we can
                    help.</p>
                <a href="/contact/" className="btn btn--outline btn--gray">Contact WoodWorks</a>
                <a href="/join-now/" style={{marginLeft: '25px'}} className="btn btn--outline btn--project-add-modal">Add A Project</a>
            </div>
        </React.Fragment>
    );
}

const ProjectHitsPanel = connectHits(Hits);
export default ProjectHitsPanel;
